import moment from "moment-timezone";

import { Store } from "~/bff/types/Store";
import { StoreDetailsPageTranslations } from "~/bff/types/StoreDetailsPageTranslations";
import { Nullable } from "~/types/general.types";

import { getDayFromDate } from "./get-day-from-date";
import { getLocalizedDaysText } from "./get-localized-days-text";
import { getStoreOrServiceStatus } from "./get-store-or-service-status";

export const getStoreOrServiceLabel = ({
  regularHours,
  holidayHours,
  timezone,
  translations,
}: {
  regularHours: Store["hours"];
  holidayHours?: Store["holidayHours"];
  timezone?: string;
  translations?: Nullable<StoreDetailsPageTranslations> | undefined;
}): string | null => {
  const { status, openDate, closeDate } = getStoreOrServiceStatus({
    regularHours,
    holidayHours,
    timezone,
  });

  if (!openDate && !closeDate) {
    return null;
  }

  if (status === "open") {
    return `${translations?.storeOpenedUntil} ${closeDate?.format("HH:mm")}`;
  }

  if (status === "closed") {
    const isOpenDayToday = openDate?.isSame(moment(), "day");
    const localizedDaysText = getLocalizedDaysText(translations ?? undefined);
    const dayFromOpenDate = getDayFromDate(openDate);

    const openDay: string = isOpenDayToday
      ? ""
      : dayFromOpenDate
        ? localizedDaysText[dayFromOpenDate]
        : "";

    return `${translations?.storeOpensAt} ${openDate?.format("HH:mm")} ${openDay}`.trim();
  }

  return null;
};
